
import head from '../mixins/MetaHead'
import { privacyContent } from '../fc/Constants/privacy-content'

export default {
  name: 'Privacy',
  mixins: [head],
  data () {
    return {
      title: 'Online Converter - Convert Image, Video, Audio, & Document Files',
      desc:
        'Free online file Converter to convert your image, video, document, and music files from one format to another.',
      currentUrl: '/privacy'
    }
  },
  computed: {
    privacyContent () {
      return privacyContent(this)
    }
  },
  mounted () {
    this.$store.commit('updateBreadcrumbs', [
      {
        url: this.localePath('/privacy'),
        label: this.$t('privacy')
      }
    ])
  }
}
